import React from "react";
import { ShieldCheck, Lock, Award, Heart, RotateCcw, MapPin } from "lucide-react";

const ITEMS = [
  {
    icon: ShieldCheck,
    title: "Verified Business",
    sub: "Registered in Dubai · UAE · Trade License #DP-2018-0942",
  },
  {
    icon: Lock,
    title: "256-bit SSL Checkout",
    sub: "Stripe-secured payments · PCI-DSS Level 1",
  },
  {
    icon: RotateCcw,
    title: "100-Night Risk-Free Trial",
    sub: "Sleep on it. Don't love it? Full refund — no questions.",
  },
  {
    icon: Award,
    title: "7-Star Hotel Grade",
    sub: "Same goose down used by luxury hotels in Dubai & Geneva",
  },
  {
    icon: Heart,
    title: "12,400+ Happy Sleepers",
    sub: "Average rating 4.93/5 from verified buyers worldwide",
  },
  {
    icon: MapPin,
    title: "Real Humans · Real Support",
    sub: "support@dubaipillows.com · we reply in under 4h",
  },
];

export default function TrustReinforcer() {
  return (
    <section
      data-testid="trust-reinforcer"
      className="py-16 md:py-20 bg-[#fafaf9] border-y border-black/5"
    >
      <div className="container-x">
        <div className="text-center">
          <div className="text-[10px] uppercase tracking-[0.25em] font-extrabold text-[#8a8a8a]">
            Why customers trust us
          </div>
          <h2 className="mt-3 text-[26px] sm:text-[34px] md:text-[42px] font-black tracking-[-0.02em] text-[#0e0e10]">
            A serious brand, not a dropshipper.
          </h2>
          <p className="mt-3 text-[#5a5a60] text-[14px] max-w-xl mx-auto">
            We&apos;ve been hand-stitching pillows in Dubai since 2018. Every order is backed by a verified business, secure payments and real people who reply.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {ITEMS.map((it) => {
            const Icon = it.icon;
            return (
              <div
                key={it.title}
                className="rounded-2xl bg-white border border-black/5 p-5 hover:shadow-md transition"
              >
                <div className="flex items-start gap-3.5">
                  <span className="shrink-0 w-11 h-11 rounded-xl bg-[#0e0e10] text-white inline-flex items-center justify-center">
                    <Icon size={18} />
                  </span>
                  <div>
                    <div className="text-[14px] font-black text-[#0e0e10] leading-tight">
                      {it.title}
                    </div>
                    <div className="mt-1 text-[12px] text-[#5a5a60] leading-snug">
                      {it.sub}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
